export default __webpack_public_path__ + "static/media/Resume_Mohosin Islam Palash_MERN Stack Developer.7d08298e.pdf";